import { render } from "./Ref.vue?vue&type=template&id=d690435a"
import script from "./Ref.vue?vue&type=script&lang=ts"
export * from "./Ref.vue?vue&type=script&lang=ts"
script.render = render

export default script